import React from "react";
import Icon, { IconProps } from "../Icon";
import { externalBrandColors } from "@puzzle/theme";

export default function DarkPuzzleLogo({ viewBox = "0 0 32 32", ...iconProps }: IconProps) {
  return (
    <Icon width={32} height={32} {...iconProps} viewBox={viewBox}>
      <path
        fill={externalBrandColors.puzzle.puzzleGreen}
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
      ></path>
      <path
        fill={externalBrandColors.puzzle.puzzleLight}
        d="M13.6 6.4l-4.8 4.8h4.8V16l-4.8 4.8h4.8v4.8l4.8-4.8h-4.8V16l4.8-4.8h-4.8V6.4z"
      ></path>
      <path
        fill={externalBrandColors.puzzle.puzzleDark}
        fillRule="evenodd"
        d="M18.4 20.8A7.199 7.199 0 0023.49 8.51 7.2 7.2 0 0018.4 6.4h-4.8v4.8H8.8V16h4.8v4.8H8.8v4.8h4.8v-4.8h4.8zm0-4.8v-4.8h-4.8V16h4.8z"
        clipRule="evenodd"
      ></path>
    </Icon>
  );
}
